/** CoStar.Api.ListingManagerMessaging.Unsubscribe.UnsubscribeCategory */
export var UnsubscribeCategory;
(function (UnsubscribeCategory) {
    UnsubscribeCategory[UnsubscribeCategory["None"] = 0] = "None";
    UnsubscribeCategory[UnsubscribeCategory["PendingListingExpiration"] = 1] = "PendingListingExpiration";
    UnsubscribeCategory[UnsubscribeCategory["All"] = 2147483647] = "All";
})(UnsubscribeCategory || (UnsubscribeCategory = {}));
